import React, { Component } from 'react';

class Modal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hidden: true,
    };
  }

  showModal(title, description) {
    this.setState({
      hidden: false,
      title,
      description,
    });
  }

  render() {
    const { title, description, hidden } = this.state;
    return (
      <div className={hidden ? 'hidden' : ''}>
        <div id="errorModal" className="modal error">
          <div className="modal-header">
            <h3 id="errorTitle">{title}</h3>
          </div>
          <div className="modal-body">
            <p id="errorDescription">{description}</p>
          </div>
        </div>
        <div className="overlay" />
      </div>
    );
  }
}

export default Modal;
